module.exports = __webpack_public_path__ + "img/Ball-back-first.9c19d462.jpg";